
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>SWAR RANG</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm swar-rang section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Swar<span>rang</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-9">
                <div class=" text-justify">
                    <h2 class="head-lea">SWAR RANG <span class="small-sm">24 JANUARY 2020</span></h2>
                    <p>On this Holi, You are invited to experience colors of Holi through Holi Geet program on 9th March
                        2020 @ 6.15 PM</p>

                    <h6 class="fw-bold">LET'S GET WET WITH THE HOLI SWAR RANG</h6>
                    <h6 class="fw-bold">ENTRY FREE</h6>
                    <p>Date : 9 <sup>th</sup> March 2020</p>
                    <p>Time : 6.15 PM</p>
                    <p>Venue : Hamsa Hall, Soham home for senior living, next to Sevasadan saksham school, Sitabuldi,
                        Nagpur</p>

                    <h6 class="fw-bold">GHRSCF WISHES YOU A VERY HAPPY, MUSICAL AND COLORFUL HOLI.</h6>
                </div>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swar-banner.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>PHOTOS</h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="photogallery" class="btn button--effect-1"><span>
                        View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                </a>
            </div>
        </div>

        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swr-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
            </ul>

        </div>

    </div>

</section>
